









import { defineComponent, computed } from '@vue/composition-api'

enum PaymentStatus {
  Initiated = 'initiated',
  Paid = 'paid',
  Cancelled = 'cancelled',
  Pending = 'pending',
  Refunded = 'refunded'
}

export default defineComponent({
  name: 'PaymentStatusBadge',

  props: {
    status: {
      type: String,
      require: true
    }
  },

  setup(props) {
    const classes = computed(() => {
      switch (props.status) {
        case PaymentStatus.Cancelled:
          return ['bg-red-200', 'text-red-600']
        case PaymentStatus.Refunded:
          return ['bg-yellow-200', 'text-yellow-600']
        case PaymentStatus.Initiated:
          return ['bg-gray-200', 'text-gray-600']
        case PaymentStatus.Paid:
          return ['bg-teal-200', 'text-teal-800']
        case PaymentStatus.Pending:
          return ['bg-orange-200', 'text-orange-600']
        default:
          return ['bg-purple-200', 'text-purple-600']
      }
    })

    return {
      classes
    }
  }
})
